<div class="container-fluid">
  <div class="d-flex justify-content-between align-items-center my-3">
    <h3>{{ 'FILTER_SEARCH_STATS' | translate }}</h3>
    <button type="button" class="btn btn-secondary" (click)="export()" [disabled]="exporting">
      {{ 'EXPORT_EXCEL' | translate }}
    </button>
  </div>

  <div class="row align-items-end mb-3">
    <div class="col-auto">
      <label>{{ 'FROM_DATE' | translate }}</label>
      <input type="date" class="form-control" [(ngModel)]="fromDate" (change)="onFromDateChange(fromDate)" />
    </div>
    <div class="col-auto">
      <label>{{ 'TO_DATE' | translate }}</label>
      <input type="date" class="form-control" [(ngModel)]="toDate" (change)="onToDateChange(toDate)" />
    </div>
    <div class="col-auto btn-group">
      <button type="button" class="btn btn-outline-secondary" (click)="setPreset(7)">7d</button>
      <button type="button" class="btn btn-outline-secondary" (click)="setPreset(30)">30d</button>
      <button type="button" class="btn btn-outline-secondary" (click)="setPreset(90)">90d</button>
    </div>
  </div>

  <table class="table table-sm table-striped">
    <thead>
      <tr>
        <th>{{ 'TIMESTAMP' | translate }}</th>
        <th>{{ 'SEARCH_TERM' | translate }}</th>
        <th>{{ 'TIER' | translate }}</th>
        <th class="text-right">{{ 'TOTAL_HITS' | translate }}</th>
        <th class="text-right">ms</th>
        <th>{{ 'HITS_PER_SOURCE' | translate }}</th>
        <th>{{ 'USER' | translate }}</th>
        <th>{{ 'CUSTOMER' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (entry of page?.content; track entry.id) {
        <tr>
          <td>{{ entry.timestamp | date: 'yyyy-MM-dd HH:mm' }}</td>
          <td>{{ entry.term }}</td>
          <td>{{ entry.tier }}</td>
          <td class="text-right">{{ entry.totalHits }}</td>
          <td class="text-right">{{ entry.durationMs }}</td>
          <td class="small">{{ renderHitsPerSource(entry) }}</td>
          <td>{{ entry.userId }}</td>
          <td>{{ entry.customerId }}</td>
        </tr>
      }
    </tbody>
  </table>

  @if (page && page.content.length === 0 && !loading) {
    <p class="text-muted">{{ 'NO_SEARCHES_IN_PERIOD' | translate }}</p>
  }

  @if (page) {
    <div class="d-flex justify-content-between align-items-center">
      <span>{{ page.totalElements }} {{ 'SEARCHES' | translate }}</span>
      <div class="btn-group">
        <button
          type="button"
          class="btn btn-outline-secondary"
          [disabled]="page.number === 0 || loading"
          (click)="load(page.number - 1)"
        >
          {{ 'PREVIOUS' | translate }}
        </button>
        <span class="btn btn-outline-secondary disabled">{{ page.number + 1 }} / {{ page.totalPages || 1 }}</span>
        <button
          type="button"
          class="btn btn-outline-secondary"
          [disabled]="page.number >= page.totalPages - 1 || loading"
          (click)="load(page.number + 1)"
        >
          {{ 'NEXT' | translate }}
        </button>
      </div>
    </div>
  }
</div>
